import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyBJkqh1Zq05GgejqkgJG-bDrWIbd1Uj_l8",
  authDomain: "netflix-clone-cf59f.firebaseapp.com",
  projectId: "netflix-clone-cf59f",
  storageBucket: "netflix-clone-cf59f.appspot.com",
  messagingSenderId: "43289882073",
  appId: "1:43289882073:web:a8b8542dd8d6075909bdc8"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth  = getAuth(firebaseApp);

export { auth };
export default db;

